(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[273],{

/***/ 583:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invite",
      function () {
        return __webpack_require__(2082);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fm": function() { return /* binding */ transformPriceToNumber; },
/* harmony export */   "zF": function() { return /* binding */ transformPrice; }
/* harmony export */ });
/* unused harmony export formatPrice */
var transformPrice = function(price, locale, currency) {
    var value = typeof price === "number" ? price / 100 : 0;
    try {
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency !== null && currency !== void 0 ? currency : "eur",
            currencyDisplay: "narrowSymbol",
            minimumFractionDigits: 0
        }).format(value);
    } catch (e) {
        // Support pour les vieux navigateurs
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency !== null && currency !== void 0 ? currency : "eur",
            currencyDisplay: "symbol",
            minimumFractionDigits: 0
        }).format(value);
    }
};
var transformPriceToNumber = function(price) {
    var value = typeof price === "number" ? price / 100 : 0;
    return value.toFixed(2);
};
var formatPrice = function(value, locale, currency) {
    try {
        return Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency !== null && currency !== void 0 ? currency : "eur",
            currencyDisplay: "narrowSymbol",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(value);
    } catch (e) {
        // Support pour les vieux navigateurs
        return Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency !== null && currency !== void 0 ? currency : "eur",
            currencyDisplay: "symbol",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(value);
    }
};


/***/ }),

/***/ 4385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SaleProductComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4364);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(619);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4658);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _sale_product_component_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9896);
/* harmony import */ var _sale_product_component_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_sale_product_component_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6511);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5350);
/* harmony import */ var _api_currency__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5283);









var SaleProductComponent = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(SaleProductComponent, _PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(SaleProductComponent);
    function SaleProductComponent() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, SaleProductComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            idx: 0
        };
        _this.getImage = function(size) {
            if (_this.props.product.image) {
                return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .transformImage */ .W)(_this.props.product.image, size * _this.props.imageWidth + "x" + size * _this.props.imageWidth, true, _this.props.hasWebp);
            }
            return "";
        };
        return _this;
    }
    var _proto = SaleProductComponent.prototype;
    _proto.render = function render() {
        var isOutOfStock = this.props.product.price_range[0] === -1 && this.props.product.price_range[1] === -1;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (this.props.className || "") + " " + (_sale_product_component_module_scss__WEBPACK_IMPORTED_MODULE_7___default().product),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    height: "auto",
                    width: "100%",
                    disableWebp: true,
                    containerClassName: (this.props.quantity === 0 ? "empty " : "") + (_sale_product_component_module_scss__WEBPACK_IMPORTED_MODULE_7___default().imageContainer),
                    // , ${this.getImage(3)} 3x
                    srcSet: "".concat(this.getImage(2), " 2x"),
                    className: (_sale_product_component_module_scss__WEBPACK_IMPORTED_MODULE_7___default().main),
                    src: this.getImage(1),
                    alt: "image product",
                    style: {
                        opacity: isOutOfStock ? 0.3 : 1
                    },
                    children: this.props.discountValue ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_sale_product_component_module_scss__WEBPACK_IMPORTED_MODULE_7___default().discount),
                        children: this.props.discountValue
                    }) : undefined
                }),
                this.props.displayBrand && (this.props.product.title || this.props.brand_name) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                    children: this.props.brand_name || this.props.product.title
                }) : null,
                !this.props.variant || this.props.variant !== "simple" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                            children: this.props.name
                        }),
                        this.renderPrice(isOutOfStock),
                        this.props.triggerText && this.props.quantity !== 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_sale_product_component_module_scss__WEBPACK_IMPORTED_MODULE_7___default().stock),
                            children: this.props.triggerText
                        }) : null
                    ]
                }) : null
            ]
        });
    };
    _proto.renderPrice = function renderPrice(isOutOfStock) {
        if (isOutOfStock) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                style: {
                    color: "orange"
                },
                children: "Out of stock"
            });
        }
        if (this.props.product.price_range[0] !== this.props.product.price_range[1]) {
            var opt = this.props.product.options[this.props.product.options.length - 1];
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        children: [
                            this.props.wording,
                            " ",
                            (0,_api_currency__WEBPACK_IMPORTED_MODULE_8__/* .transformPrice */ .zF)(this.props.product.price_range[0], this.props.locale, this.props.currency),
                            " ",
                            this.props.product.minimum_retail_price !== this.props.product.price_range[0] && this.props.product.price_range[0] ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: (0,_api_currency__WEBPACK_IMPORTED_MODULE_8__/* .transformPrice */ .zF)(this.props.product.minimum_retail_price, this.props.locale, this.props.currency)
                            }) : null
                        ]
                    }),
                    opt ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        style: {
                            color: "grey",
                            fontWeight: "normal",
                            fontSize: 12
                        },
                        children: [
                            opt.cardinality,
                            " ",
                            opt.label,
                            opt.cardinality > 1 ? "s" : ""
                        ]
                    }) : null
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
            children: [
                (0,_api_currency__WEBPACK_IMPORTED_MODULE_8__/* .transformPrice */ .zF)(this.props.product.price_range[0], this.props.locale, this.props.currency),
                " ",
                this.props.product.minimum_retail_price !== this.props.product.price_range[0] && this.props.product.price_range[0] ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: (0,_api_currency__WEBPACK_IMPORTED_MODULE_8__/* .transformPrice */ .zF)(this.props.product.minimum_retail_price, this.props.locale, this.props.currency)
                }) : null
            ]
        });
    };
    return SaleProductComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);



/***/ }),

/***/ 2082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(4364);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(619);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(5034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(169);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(2050);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4658);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(9497);
/* harmony import */ var _styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _components_meta_header_meta_header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6514);
/* harmony import */ var _new_components_header_Header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5365);
/* harmony import */ var _new_components_footer_Footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5374);
/* harmony import */ var _api_analytics__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(1936);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5509);
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8446);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6071);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(390);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7425);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1443);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _utils_lang__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(3703);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3496);
/* harmony import */ var _api_currency__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(5283);
/* harmony import */ var _utils_image__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(5350);
/* harmony import */ var _components_sale_product_sale_product_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4385);
/* harmony import */ var _components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6511);
/* harmony import */ var _utils_agent__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9754);













// Import Swiper React components


// Import Swiper styles
// Import Swiper styles











var referralsEN = [
    {
        text: "I literally get so excited checking the app each day at 7am to see what new products and items are available for purchase!",
        name: "Hannah",
        time: "Chooser since 1 month"
    },
    {
        text: "I love that Choose offers a variety of products and brands all in one app. Makes shopping and styling very convenient!",
        name: "Shani",
        time: "Chooser since 3 months"
    },
    {
        text: "Choose is actually a great shopping app.I love that they offer a wide variety of brands that offer great quality products at a discounted price.",
        name: "Ny",
        time: "Chooser since 2 months"
    },
    {
        text: "I would describe choose as the best shopping app I\u2019ve ever tried.",
        name: "Allison",
        time: "Chooser since 3 months"
    },
    {
        text: "I like Choose because it seems to be a reliable source of curated brands that oftentimes align with my values.",
        name: "Teralyn",
        time: "Chooser since 1 year"
    }, 
];
var referralsFR = [
    {
        text: "Enfin des ventes sur des produits responsables. Choose rend accessible la qualit\xe9 \xe0 des petits budgets familiaux. J'adore les marques propos\xe9es, il s'agit souvent de produits que j'avais rep\xe9r\xe9 mais que je ne pouvais pas m\u2019offrir.",
        name: "Sabrina",
        time: "Utilisatrice depuis 1 mois"
    },
    {
        text: "Toujours de chouettes marques propos\xe9es. Bon SAV, tr\xe8s r\xe9actif si probl\xe8me avec les marques.",
        name: "Laura",
        time: "Utilisatrice depuis 3 mois"
    },
    {
        text: "Une appli qui pr\xe9sente des marques de belles qualit\xe9s. Jamais d\xe9\xe7ue",
        name: "Morgane",
        time: "Utilisatrice depuis 2 mois"
    },
    {
        text: "Je suis conquise! Il y a tellement de choix qu\u2019il est impossible de ne pas trouver son bonheur.",
        name: "Christelle",
        time: "Utilisatrice depuis 3 mois"
    },
    {
        text: "De chouettes marques avec r\xe9guli\xe8rement des nouveaut\xe9s. J'ai fait de jolies d\xe9couvertes avec Choose. Jamais d\xe9\xe7ue de mes achats depuis 2 ans. La qualit\xe9 est au RDV.",
        name: "Fanny",
        time: "Utilisatrice depuis 3 ans"
    }, 
];
var ProductComponent = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(ProductComponent, _PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(ProductComponent);
    function ProductComponent() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(this, ProductComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.onClick = function() {
        //
        };
        _this.getDiscountValue = function() {
            var value = Math.floor((_this.props.product.minimum_retail_price - _this.props.product.price_range[0]) / _this.props.product.minimum_retail_price * 100);
            if (_this.props.currency === "usd") {
                return value + "% off";
            }
            return "-" + value + "%";
        };
        return _this;
    }
    var _proto = ProductComponent.prototype;
    _proto.render = function render() {
        var url = "/product/" + this.props.product.product_key + "?v=" + this.props.token;
        if (this.props.product.collapse_key) {
            url += "&collapse_key=" + encodeURIComponent(this.props.product.collapse_key);
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: this.props.className || "col-3 col-sm-6 col-md-6",
            href: url,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sale_product_sale_product_component__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                position: this.props.position,
                variant: this.props.variant,
                currency: this.props.currency,
                disableLazy: true,
                wording: this.props.wording,
                onClick: this.onClick,
                locale: this.props.locale,
                name: this.props.product.subtitle,
                product: this.props.product,
                quantity: this.props.product.stock,
                displayBrand: this.props.variant === "simple" || this.props.variant === "selection",
                discountValue: this.getDiscountValue(),
                brand_name: this.props.product.title,
                imageWidth: this.props.imageWidth || 265,
                hasWebp: this.props.hasWebp
            })
        });
    };
    return ProductComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);
function InviteScreen(props) {
    var onClickApple = function onClickApple() {
        (0,_api_analytics__WEBPACK_IMPORTED_MODULE_18__/* .trackEventSegment */ .P)("clickApple", {
            from: "invite"
        });
    };
    var onclickAndroid = function onclickAndroid() {
        (0,_api_analytics__WEBPACK_IMPORTED_MODULE_18__/* .trackEventSegment */ .P)("clickAndroid", {
            from: "invite"
        });
    };
    var getTrad = function getTrad(str) {
        if (props.user && props.user.reward_amount && props.user.currency) {
            return t(str, {
                name: props.user.firstname || props.user.name,
                amount: (0,_api_currency__WEBPACK_IMPORTED_MODULE_19__/* .transformPrice */ .zF)(props.user.reward_amount, i18n.language, props.user.currency)
            });
        }
    };
    var getAsterix = function getAsterix(str) {
        if (props.user && props.user.currency) {
            return t(str, {
                amount: (0,_api_currency__WEBPACK_IMPORTED_MODULE_19__/* .transformPrice */ .zF)(props.user.reward_minimum, i18n.language, props.user.currency)
            });
        }
    };
    var getStoresBtn = function getStoresBtn(str) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().btnsStores),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().dwl),
                    children: getTrad(str)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().ap),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            style: {
                                marginRight: 16
                            },
                            onClick: onClickApple,
                            title: "Apple Store",
                            className: "plausible-event-name=Download+App plausible-event-platform=apple plausible-event-from=invite",
                            href: "https://apps.apple.com/fr/app/choose-concept-store/id985799982?mt=8&ct=website",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                width: "134",
                                alt: "Apple Store",
                                height: "40",
                                src: "https://public.choose.app/website/new/images/btn-small-app-store-".concat((0,_utils_lang__WEBPACK_IMPORTED_MODULE_21__/* .getLang */ .V)(), ".svg")
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "plausible-event-name=Download+App plausible-event-platform=android plausible-event-from=invite",
                            onClick: onclickAndroid,
                            href: "https://play.google.com/store/apps/details?id=com.appchoose.choose.android&hl=fr&gl=FR",
                            rel: "noopener noreferrer",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                height: "41",
                                width: "136",
                                alt: "Play Store",
                                src: "https://public.choose.app/website/new/images/btn-small-play-store-".concat((0,_utils_lang__WEBPACK_IMPORTED_MODULE_21__/* .getLang */ .V)(), ".svg")
                            })
                        })
                    ]
                })
            ]
        });
    };
    var getDescription = function getDescription() {
        if (props.user && props.user.referral_code) {
            return "".concat(getTrad("description"), " ").concat(props.user.referral_code.toUpperCase(), " !");
        }
        return "";
    };
    var getTitle = function getTitle() {
        if (props.user) {
            return "Choose | ".concat(props.user.firstname || props.user.name, " ").concat(getTrad("title"));
        }
        return "";
    };
    var getDownloadLink = function getDownloadLink(from) {
        return "https://gmgb.adj.st/invite/".concat(props.user.referral_code, "?adj_t=14t7o91a&adj_label=code&adj_campaign=siteweb&adj_adgroup=referral&code=").concat(props.user.referral_code, "&from=").concat(from);
    };
    var onClick = function onClick(from) {
        window.location.href = getDownloadLink(from);
        (0,_api_analytics__WEBPACK_IMPORTED_MODULE_18__/* .trackEventSegment */ .P)("Clickapp", {
            from: from,
            page: "invite"
        });
    };
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,next_i18next__WEBPACK_IMPORTED_MODULE_11__/* .useTranslation */ .$G)("invite"), t = ref5.t, i18n = ref5.i18n;
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({}), 2), userAgent = ref6[0], setUserAgent = ref6[1];
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState([]), 2), referrals = ref7[0], setReferrals = ref7[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        var ua = (0,_utils_agent__WEBPACK_IMPORTED_MODULE_14__/* .getUserAgent */ .i)();
        setUserAgent(ua);
        (0,_api_analytics__WEBPACK_IMPORTED_MODULE_18__/* .trackPage */ .K)("Invite");
        if (i18n.language === "fr") {
            setReferrals(referralsFR);
        } else {
            setReferrals(referralsEN);
        }
    }, []);
    var _store;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().invite), " beige invite-page"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_meta_header_meta_header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                image: "https://public.choose.app/website/new/images/Referral-Thumbnail-Sharing.jpg",
                pageTitle: getTitle(),
                description: getDescription(),
                title: getTitle(),
                noIndex: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_new_components_header_Header__WEBPACK_IMPORTED_MODULE_3__/* .HeaderNewComponent */ .w, {
                disableScroll: true,
                hideBtns: true,
                variant: "beige-center",
                store: props.store,
                language: i18n.language
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "".concat((_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().container_what)),
                    children: [
                        props.store === "us" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().imgmobile),
                                    src: "https://public.choose.app/website/new/invite/Choose_App.png",
                                    srcSet: "https://public.choose.app/website/new/invite/Choose_App@2x.png 2x, https://public.choose.app/website/new/invite/Choose_App@3x.png 3x"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().imgdesktop),
                                    src: "https://public.choose.app/website/new/invite_desktop/Choose_App.png",
                                    srcSet: "https://public.choose.app/website/new/invite_desktop/Choose_App@2x.png 2x, https://public.choose.app/website/new/invite_desktop/Choose_App@3x.png 3x"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().imgmobile),
                                    src: "https://public.choose.app/website/new/invite/Choose_App_FR.png",
                                    srcSet: "https://public.choose.app/website/new/invite/Choose_App_FR@2x.png 2x, https://public.choose.app/website/new/invite/Choose_App_FR@3x.png 3x"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().imgdesktop),
                                    src: "https://public.choose.app/website/new/invite_desktop/Choose_App_FR.png",
                                    srcSet: "https://public.choose.app/website/new/invite_desktop/Choose_App_FR@2x.png 2x, https://public.choose.app/website/new/invite_desktop/Choose_App_FR@3x.png 3x"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().btns),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: t("referral_choose_slogan")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: t("referral_choose_slogan_text")
                                }),
                                getStoresBtn("referral_download"),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "".concat((_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().app), " plausible-event-name=Download+App plausible-event-btn=download plausible-event-from=invite"),
                                    onClick: function() {
                                        return onClick("download");
                                    },
                                    children: t("referral_download")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container",
                children: [
                    props.user && props.user.name ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().h2code),
                        children: getTrad("referral-title")
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().description),
                        children: t("referral_use_code")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat((_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().codecontainer)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: (ref = props.user) === null || ref === void 0 ? void 0 : (ref1 = ref.referral_code) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase()
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().asterix),
                        children: getAsterix("referral-minimum")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "".concat((_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().app), " plausible-event-name=Download+App plausible-event-btn=use plausible-event-from=invite"),
                        style: {
                            display: "block"
                        },
                        onClick: function() {
                            return onClick("use");
                        },
                        children: t("referral_use_it")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().container)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().productsh2),
                            children: t("referral_products")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "".concat((_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().products)),
                            children: (ref2 = props.products) === null || ref2 === void 0 ? void 0 : ref2.map(function(product, position) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductComponent, {
                                    hasWebp: false,
                                    currency: props.user.currency,
                                    locale: i18n.language || "fr",
                                    token: "",
                                    wording: "from",
                                    variant: "selection",
                                    product: product,
                                    position: position
                                }, position);
                            })
                        }),
                        getStoresBtn("referral_discover"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "".concat((_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().app), " plausible-event-name=Download+App plausible-event-btn=discover plausible-event-from=invite"),
                            onClick: function() {
                                return onClick("discover");
                            },
                            children: t("referral_discover")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().containerbadges),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().badgestext),
                                    children: t("referral_brands")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                            className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().badges),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    children: [
                                                        props.store === "us" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "https://public.choose.app/badges/Made%20in%20USA@3x.png"
                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "https://public.choose.app/badges/Made%20in%20France@3x.png"
                                                        }),
                                                        props.store === "us" ? "Made in the USA" : "Made in France"
                                                    ]
                                                }),
                                                props.store === "us" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "https://public.choose.app/badges/Women%20Owned@3x.png"
                                                        }),
                                                        t("referral_badge_women")
                                                    ]
                                                }) : undefined,
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "https://public.choose.app/badges/Eco-friendly@3x.png"
                                                        }),
                                                        t("referral_badge_eco")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "https://public.choose.app/badges/Fait%20main@3x.png"
                                                        }),
                                                        t("referral_badge_handmade")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "https://public.choose.app/badges/Socialement%20engage%CC%81e@3x.png"
                                                        }),
                                                        t("referral_badge_good")
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().more),
                                            children: t("referral_more")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "".concat((_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().containerlove)),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: t("referral_love")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().stamp),
                            src: "https://public.choose.app/website/new/invite/Stamp.png",
                            srcSet: "https://public.choose.app/website/new/invite/Stamp@2x.png 2x, https://public.choose.app/website/new/invite/Stamp@3x.png 3x"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().rate),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "https://public.choose.app/website/new/invite/Stars.png",
                                    srcSet: "https://public.choose.app/website/new/invite/Stars@2x.png 2x, https://public.choose.app/website/new/invite/Stars@3x.png 3x"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: t("referral_rating")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .tq, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({}, {
                            modules: [
                                swiper_modules__WEBPACK_IMPORTED_MODULE_6__/* .Navigation */ .W_,
                                swiper_modules__WEBPACK_IMPORTED_MODULE_6__/* .Pagination */ .tl,
                                swiper_modules__WEBPACK_IMPORTED_MODULE_6__/* .Scrollbar */ .LW,
                                swiper_modules__WEBPACK_IMPORTED_MODULE_6__/* .A11y */ .s5
                            ]
                        }), {
                            pagination: {
                                clickable: true
                            },
                            spaceBetween: !userAgent.isMobile ? 56 : 0,
                            slidesPerView: !userAgent.isMobile ? 2 : 1,
                            children: referrals.map(function(r, i) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
                                    className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().slide),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            children: r.text
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: "https://public.choose.app/website/new/invite/Avatar.png",
                                                    srcSet: "https://public.choose.app/website/new/invite/Avatar@2x.png 2x, https://public.choose.app/website/new/invite/Avatar@3x.png 3x"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().swipername),
                                                    children: [
                                                        r.name,
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().swipertime),
                                                            children: r.time
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, i);
                            })
                        }))
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().container), " ").concat((_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().containernext)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().containernextdesktop),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: t("referral_next")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: (_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().containertextnext),
                                    children: t("referral_next_text")
                                }),
                                getStoresBtn("referral_next_download")
                            ]
                        }),
                        props.sales.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat((_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().images), " container"),
                            children: [
                                props.sales[0] ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "".concat((_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().co5)),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: (ref3 = props.sales[0]) === null || ref3 === void 0 ? void 0 : ref3.name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_image__WEBPACK_IMPORTED_MODULE_25__/* .transformImage */ .W)(props.sales[0].image_header, "600x384")
                                        })
                                    ]
                                }) : undefined,
                                props.sales[1] ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "".concat((_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().co7)),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: (ref4 = props.sales[1]) === null || ref4 === void 0 ? void 0 : ref4.name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_image__WEBPACK_IMPORTED_MODULE_25__/* .transformImage */ .W)(props.sales[1].image_header, "600x384")
                                        })
                                    ]
                                }) : undefined,
                                props.sales[2] ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "".concat((_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().co7)),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: props.sales[2].name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_image__WEBPACK_IMPORTED_MODULE_25__/* .transformImage */ .W)(props.sales[2].image_header, "600x384")
                                        })
                                    ]
                                }) : undefined,
                                props.sales[3] ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "".concat((_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().co5)),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: props.sales[3].name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: (0,_utils_image__WEBPACK_IMPORTED_MODULE_25__/* .transformImage */ .W)(props.sales[3].image_header, "600x384")
                                        })
                                    ]
                                }) : undefined
                            ]
                        }) : undefined,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "".concat((_styles_pages_invite_module_scss__WEBPACK_IMPORTED_MODULE_20___default().app), " plausible-event-name=Download+App plausible-event-btn=download2 plausible-event-from=invite"),
                            onClick: function() {
                                return onClick("download2");
                            },
                            children: t("referral_next_download")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_new_components_footer_Footer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                variant: "white",
                store: (_store = props.store) !== null && _store !== void 0 ? _store : "fr"
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (InviteScreen);


/***/ }),

/***/ 5350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ transformImage; }
/* harmony export */ });
var transformImage = function(image, sizes, removeFit, _webP) {
    if (image) {
        image = image.replace(":format(webp)", "").replace("resize:fit", "resize:fill");
        if (removeFit) {
            image = image.replace("full-fit-in/", "").replace("fit-in/", "");
        }
        return image.replace("[W]x[H]/", sizes + "/");
    }
    return "";
};


/***/ }),

/***/ 9896:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product":"sale-product-component_product__rIXEM","discount":"sale-product-component_discount__hyf09","imageContainer":"sale-product-component_imageContainer__y_doM","image-container":"sale-product-component_image-container__32_qD","empty":"sale-product-component_empty__voSZc","blurred":"sale-product-component_blurred__A86O8","main":"sale-product-component_main__p5nYn","stock":"sale-product-component_stock__CNrHr"};

/***/ }),

/***/ 9497:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"invite":"invite_invite__CSP5W","imgmobile":"invite_imgmobile__xhcWX","imgdesktop":"invite_imgdesktop__Td33h","btnsStores":"invite_btnsStores__i0gAd","dwl":"invite_dwl__VMe2G","ap":"invite_ap__RJIRP","rate":"invite_rate__osUJk","productsh2":"invite_productsh2__5Sy99","products":"invite_products__y2ZZj","slide":"invite_slide__o6YnV","swipername":"invite_swipername___frp9","swipertime":"invite_swipertime__EGqJv","containernext":"invite_containernext__LQ9zP","containertextnext":"invite_containertextnext__lUAJx","images":"invite_images__zaHV8","co5":"invite_co5__WuTwl","co7":"invite_co7__PQAux","containerlove":"invite_containerlove__gQ67n","stamp":"invite_stamp__ih3Ab","container_what":"invite_container_what__aOl8M","btns":"invite_btns__1XyRD","more":"invite_more__MVWnn","badgestext":"invite_badgestext__7c52H","containerbadges":"invite_containerbadges__XHDcE","badges":"invite_badges__BGbOi","app":"invite_app__gLxWm","h2code":"invite_h2code__HEQq0","asterix":"invite_asterix__tJq3T","codecontainer":"invite_codecontainer__TrIbj","description":"invite_description__njqpL","container":"invite_container__jJeD0","img":"invite_img__UBK4D","stores":"invite_stores__FKX_F","caption":"invite_caption__wAvet","containernextdesktop":"invite_containernextdesktop__QTXQY"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [195,520,530,774,888,179], function() { return __webpack_exec__(583); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);